import * as components from './components'
import * as hooks from './hooks'

console.log('DTG Variants feature initialized!')

export { components, hooks }
